import script from "./modelProviderSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./modelProviderSelect.vue?vue&type=script&setup=true&lang=js"

import "./modelProviderSelect.vue?vue&type=style&index=0&id=c400d76a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c400d76a"]])

export default __exports__